import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import CargarArchivo from './cargar-archivo';
import CargasPrevias from './cargas-previas';

const CargaArchivoActualizacionCIA = () => {

  const [tipoMovimiento, setTipoMovimientoHeader] = useState('')

  return (
    <Container>
      <Card className='mt-2'>
        <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >Confirma actualización en plataforma CIA</Card.Header>
        <Card.Body>
          <CargarArchivo tipoMovimiento={tipoMovimiento} setTipoMovimientoHeader={setTipoMovimientoHeader}/>
          <CargasPrevias tipoMovimiento={tipoMovimiento} /> 
        </Card.Body>
      </Card>
    </Container>
  )
}
export default CargaArchivoActualizacionCIA
